import React from 'react';
import { BlockLayoutProps } from 'ui-builder';

export default function ItemsListLayout(props: BlockLayoutProps) {
  const className = ['flex flex-col gap-3', props.className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={className}
      data-testid={props.testID}
    >
      {props.children}
    </div>
  );
}
